import { render, staticRenderFns } from "./ApprovalsIcons.vue?vue&type=template&id=3bc70c6a&scoped=true&"
import script from "./ApprovalsIcons.vue?vue&type=script&lang=js&"
export * from "./ApprovalsIcons.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalsIcons.vue?vue&type=style&index=0&id=3bc70c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc70c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc70c6a')) {
      api.createRecord('3bc70c6a', component.options)
    } else {
      api.reload('3bc70c6a', component.options)
    }
    module.hot.accept("./ApprovalsIcons.vue?vue&type=template&id=3bc70c6a&scoped=true&", function () {
      api.rerender('3bc70c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/verificarQrAprobaciones/vistas/ApprovalsIcons.vue"
export default component.exports